(function () {
  if (window.__customShopOverlayInit) return;
  window.__customShopOverlayInit = true;

  function init() {
    var trigger = document.getElementById('menu-item-collections');
    var overlay = document.getElementById('shop-overlay');
    if (!trigger || !overlay) return;

    var link = trigger.querySelector(':scope > a');
    var closeBtn = overlay.querySelector('[data-shop-overlay-close]');

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('shop-overlay-open');
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('shop-overlay-open');
    }

    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
